import { InfoIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import { BannerWrapper, IconWrapper } from './TextFrom911Banner.styles';

const DidNotCallBanner = () => {
  return (
    <BannerWrapper horizontal>
      <IconWrapper>
        <InfoIcon height="16px" width="16px" />
      </IconWrapper>
      <Text color="background" ml="12px" size="normal">
        This phone number did not call 911.
      </Text>
    </BannerWrapper>
  );
};

export default DidNotCallBanner;
